import React from 'react'
import EmailJsSend from '../../components/EmailJsSend'



export default function Adventure() {
  return (
    

<EmailJsSend />

  )
}
